import { render, staticRenderFns } from "./Doc.vue?vue&type=template&id=fa07dd92&scoped=true&lang=pug"
var script = {}
import style0 from "./Doc.vue?vue&type=style&index=0&id=fa07dd92&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa07dd92",
  null
  
)

export default component.exports